<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part" role="doc-part">
<h1 class="h1p"><span aria-label="8" epub:type="pagebreak" id="page_8" role="doc-pagebreak" title="8"><span aria-label="9" epub:type="pagebreak" id="page_9" role="doc-pagebreak" title="9">PART I</span></span></h1>
<p class="img-part"><img alt="Image" src="e9781501155475/images/common01.jpg"/></p>
<blockquote class="blockquote">
<p class="part-bq">Spirituality is always eventually</p>
<p class="part-bq">about what you do with your pain.</p>
<p class="part-bqatt">—Fr. Richard Rohr</p>
</blockquote>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?68e90668